import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				height: "100vh",
				position: "relative"
			},
			bodyPage: {
				transform: "translate(0, -50%)",
				width: "100%",
				top: "50%",
				position: "absolute"
			},
			text: {
				color: theme.palette.grey[500],
				fontSize: 15,
				padding: "5px 0px 40px"
			}
		}),
	{
		name: "NetworkError",
		index: 1
	}
);

export default useStyles;
